module.exports = __webpack_public_path__ + "images/category_lp/smartphone/assessment_achievements/3_f84a182718e456e6018b16ea04ffb8d7.jpg";